import styled from 'styled-components'

export const NavbarContainer = styled.div`
  width: 100%;
`

export const NavbarLinkContainer = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: flex-start;
  gap: 14px 8px;
  flex-wrap: wrap;

  &.top-menu {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    gap: 30px;
    justify-content: space-between;
    flex-wrap: nowrap;

    button {
      color: #8e92bc;
      flex: 1;
      justify-content: center;
      font-size: 14px;

      &.active {
        color: #0a0a18;
      }
    }
  }
`

export const NewItemRow = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: no-wrap;
`
